<template>
  <b-form
    id="privilege-tag"
    @submit.prevent="onSubmitForm"
  >
    <b-row>
      <b-col cols="12">
        <b-card
          no-body
          class="mb-1"
        >
          <b-card-header>
            <span class="information-header">Tag</span>
          </b-card-header>
          <div class="px-5">
            <div class="row mb-4">
              <div class="col-lg-6 col-sm-12 col-xs-12">
                <div>
                  <label for="flag-option-tag">
                    <span class="font-medium-5">{{ 'Tag' }}</span>
                  </label>
                  <v-select
                    id="flag-option-tag"
                    v-model="formData.tag"
                    multiple
                    :options="optionData.tagList"
                    :reduce="option => option.label"
                    class="tag-dropdown"
                    :map-keydown="handlers"
                    @option:selecting="onAddTag"
                    @option:deselecting="onRemoveTag"
                  />
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <div class="privilege-btn-wrp mt-2 mb-2">
      <div class="d-flex justify-content-center">
        <cancel-button
          class="mr-1"
          :btn-label="'Back'"
          @click.native="$emit('onPreviousStep')"
          stageBack
        />
         <save-button
          :type="'submit'"
          class="ml-1"
          :btn-label="'Next'"
        />
      </div>
    </div>
  </b-form>
</template>

<script>
import usePrivilegeTag from '../hooks/usePrivilegeTag'

export default {
  props: {
    isEdit: { type: Boolean, default: false },
    privilegeId: { type: Number, default: 0 },
  },
  setup(props) {
    const {
      formData,
      optionData,
      onSubmitForm,
      onRemoveTag,
      onAddTag,
      handlers,
    } = usePrivilegeTag(props)
    return {
      formData,
      optionData,
      onSubmitForm,
      onRemoveTag,
      onAddTag,
      handlers,
    }
  },
}
</script>
